// Mirrors @lexical/link 0.41.0's auto-link separator check.
const LEXICAL_AUTO_LINK_SEPARATOR_REGEX = /[.,;\s]/;
function isInsideTripleBacktickFence(context) {
    for (let openOffset = context.text.indexOf('```'); openOffset !== -1 && openOffset < context.startOffset; openOffset = context.text.indexOf('```', openOffset + 3)) {
        const closeOffset = context.text.indexOf('```', openOffset + 3);
        if (closeOffset === -1) {
            return false;
        }
        if (context.endOffset <= closeOffset) {
            return true;
        }
        openOffset = closeOffset;
    }
    return false;
}
export function isAutoLinkTextInProtectedContext(context) {
    // This intentionally uses lightweight text heuristics instead of adding markdown/code nodes.
    return isInsideTripleBacktickFence(context);
}
export function hasStockAutoLinkTextBoundaries(context) {
    const characterBefore = context.startOffset > 0 ? context.text[context.startOffset - 1] : undefined;
    const characterAfter = context.endOffset < context.text.length ? context.text[context.endOffset] : undefined;
    return isStockAutoLinkBoundary(characterBefore) && isStockAutoLinkBoundary(characterAfter);
}
function isStockAutoLinkBoundary(character) {
    return character === undefined || LEXICAL_AUTO_LINK_SEPARATOR_REGEX.test(character);
}
//# sourceMappingURL=autoLinkText.js.map